<template>
  <div class="py-7 container-fluid">
    <div class="mb-3">
      <h1>Forbidden</h1>
    </div>
  </div>
</template>
